import styled from 'styled-components'
import playImg from '../../assets/play.png'
import { useNavigate } from 'react-router-dom'

function Page3Mobile(prop) {
  const goods = prop.goods
  const gsId = prop.gsId
  const itemList = goods?.itemDtoList
  const navigate = useNavigate()

  return (
    <MainContainer>
      <Video>
        {(() => {
          if (goods.gsFileDto) {
            if (goods.gsFileDto.fileType == 'IMAGE') {
              return (
                <IMAGE
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    goods.gsFileDto.filePath
                  }
                ></IMAGE>
              )
            } else {
              return (
                <VIDEO
                  controls
                  playsInline
                  autoPlay
                  muted
                  loop
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    goods.gsFileDto.filePath
                  }
                ></VIDEO>
              )
            }
          }
        })()}
      </Video>
      <Bottom
        style={{
          background:goods.gsBgColor
        }}
      >
        <Text1
        
        style={{
          color:goods.gsFontColor
        }}
        >{goods.gsName}</Text1>
        <TitleContainer>
          <Title1
            style={{
              color:goods.gsFontColor
            }}>{goods.gsEngName}</Title1>

          <Title2
            style={{
              color:goods.gsFontColor
            }}>{goods.gsKorName}</Title2>
            
        </TitleContainer>
        <BoxContainer>
          {itemList &&
            itemList.map((item) => {
              return (
                <Box
                  
                  
                  key={item.itemSeq}
                  onClick={() => {
                    navigate(`/item/${gsId}/${item.itemSeq}`)
                  }}
                >
                  <BoxTitle
                    style={{
                      color:goods.gsFontColor
                    }}
                  >{item.itemName}</BoxTitle>
                  <View
                    style={{
                      color:goods.gsFontColor
                    }}
                  >VIEW</View>

                </Box>
              )
            })}
        </BoxContainer>
      </Bottom>
    </MainContainer>
  )
}

export default Page3Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  width: 100vw;
  height: calc(100vh);
  margin-bottom: 83.7px;
`
const Video = styled.div`
  width: 100vw;
  height: 211px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
`
const IMAGE = styled.img`
  width: 100vw;
  height: 211px;
`
const VIDEO = styled.video`
  width: 100vw;
  height: 211px;
`
const Play = styled.img`
  width: 73px;
  height: 73px;
`
const Bottom = styled.div`
  flex-direction: column;
  flex: 1;
  background: #1f1f1d;
  padding: 0px 19.8px;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: 300;
  color: #b19c70;
  font-size: 15px;
  margin-top: 36px;
`
const TitleContainer = styled.p`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 8px;
`
const Title1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  color: #b19c70;
  font-size: 30px;
`
const Title2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: 300;
  color: #b19c70;
  font-size: 18.3px;
  margin-left: 10px;
  margin-bottom: 3px;
`
const BoxContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8.1px;
  margin-top: 47.7px;
`
const Box = styled.div`
  width: 99%;
  height: 44.1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 0.3px solid #70695b;
`
const BoxTitle = styled.p`
  font-family: Noto Sans KR;
  font-weight: 400;
  color: #b19c70;
  font-size: 16.7px;
  margin-left: 11.2px;
`
const View = styled.p`
  font-family: GMarketSans;
  font-weight: light;
  color: #b19c70;
  font-size: 10px;
  margin-right: 11.2px;
`
